import { TableCell, TableRow } from '@mui/material'

import { CellCenteredProps } from './types'

export const CellCentered = ({ children, columnsCount }: CellCenteredProps): React.JSX.Element => (
  <TableRow>
    <TableCell
      align='center'
      colSpan={columnsCount}
      sx={{ border: 'none' }}
    >
      {children}
    </TableCell>
  </TableRow>
)
